import { apiPatch } from 'APIPackage/MainModule/common/apiTools';

import { IChangePasswordParams } from '../interfaces/IChangePasswordParams';

export async function changePassword(params: IChangePasswordParams): Promise<void> {
  return apiPatch<void>('/public/api/access-manager/api/users/password', params);
}
